import { CONFIG } from '../config';
import styles from './Navbar.module.css';

export default function Navbar() {
  return (
    <nav className={styles.nav}>
      <div className={styles.logo}>
        {CONFIG.siteName.slice(0, 4)}
        <span>{CONFIG.siteName.slice(4)}</span>
      </div>
      <ul className={styles.links}>
        <li><a href="#capabilities">Arsenal</a></li>
        <li><a href="#terminal">Live Feed</a></li>
        <li><a href="#onchain">Onchain</a></li>
      </ul>
      <button className={styles.cta}>{CONFIG.hero.ctaPrimary}</button>
    </nav>
  );
}
